<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve"
       version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 14889 14889"
       xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <rect class="fil0" width="14889" height="14889" rx="1452" ry="1452" />
   <rect class="fil1 str0" x="1877" y="1877" width="11136" height="11136" rx="1038" ry="1038" />
   <circle class="fil2 str1" cx="7445" cy="7445" r="374" />
 </g>
</svg>
</template>

<script>
export default {
  name: 'MultiswitchSighle',
};
</script>

<style scoped>
.str0 {
  stroke: #FEFEFE;
  stroke-width: 677.917
}

.str1 {
  stroke: #FEFEFE;
  stroke-width: 129.143
}

.fil1 {
  fill: none
}

.fil2 {
  fill: #FEFEFE
}

.fil0 {
  fill: #56D6D1
}
</style>
